module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-6.14226126.svg";